import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AdornisFilter } from '@adornis/filter/AdornisFilter.js';

// TODO abstract and move to engine dataview when porting
/**
 * @Entity
 * This entity is used to send the selection of the user list to the server. It is the interface between the users selection and the export or operation on the server.
 * All operations of the dataview should take this entity as parameter.
 */

@Entity()
export class UserListSelectionInterface extends AdornisEntity {
  static override _class = 'UserListSelectionInterface';

  constructor(doc: PartialEntityData<UserListSelectionInterface>) {
    super(doc);
  }

  // specific user ids. can be used to filter the users directly. In this case do not provide a filter ans explicitDeselectedUserIDs
  @Field(() => [String])
  public userIDs: Maybe<string[]>;

  // deselect specific users. Only allowed if you provide a filter
  @Field(() => [String])
  public explicitDeselectedUserIDs: Maybe<string[]>;

  // filter to apply to the users
  @Field(() => AdornisFilter)
  public filter: Maybe<AdornisFilter>;
}
